'use client';
import type { Options } from '@emotion/cache';
import { CacheProvider, createCache, ToastContainer, ViewupThemeProvider2 } from '@viewup/ui';
import { useServerInsertedHTML } from 'next/navigation';
import { type ReactNode, useState } from 'react';

export function ThemeRegistry(props: { children: ReactNode; options: Options }) {
  const { options, children } = props;

  const [{ cache, flush }] = useState(() => {
    const cache = createCache(options);
    cache.compat = true;
    const prevInsert = cache.insert;
    let inserted: string[] = [];
    cache.insert = (...args) => {
      const serialized = args[1];
      if (cache.inserted[serialized.name] === undefined) {
        inserted.push(serialized.name);
      }
      return prevInsert(...args);
    };
    const flush = () => {
      const prevInserted = inserted;
      inserted = [];
      return prevInserted;
    };
    return { cache, flush };
  });

  useServerInsertedHTML(() => {
    const names = flush();

    if (names.length === 0) {
      return null;
    }
    let styles = '';
    for (const name of names) {
      styles += cache.inserted[name];
    }

    return (
      <style
        // biome-ignore lint/security/noDangerouslySetInnerHtml: <emotion 에서 사용하는 코드>
        dangerouslySetInnerHTML={{
          __html: styles,
        }}
        data-emotion={`${cache.key} ${names.join(' ')}`}
        key={cache.key}
      />
    );
  });

  return (
    <CacheProvider value={cache}>
      <ViewupThemeProvider2>
        {children}
        <ToastContainer autoClose />
      </ViewupThemeProvider2>
    </CacheProvider>
  );
}
